module.exports = __webpack_public_path__ + "img/general_icon_dark.2c8399ba.svg";